<script setup>
const props = defineProps({
  navigationLinks: {
    type: Array,
    required: true,
  },
})
const route = useRoute()
const isActive = (link) => link.activeOnRoute.includes(route.path)

</script>
<template>
  <header class="fixed inset-x-0 bottom-0 z-40 w-full border-t-2 border-gray-300 bg-white xl:hidden">
    <nav>
      <ul>
        <li v-for="(link, index) in navigationLinks" :key="index">
          <NuxtLink :to="link.to" :class="[
            isActive(link) ? 'bg-green-light fill-green text-green' : 'bg-transparent text-gray-800',
            'inline-flex flex-col items-center gap-y-1 px-4 py-2 text-center text-[10px] font-bold',
          ]">
            <span v-html="link.icon"></span>
            <span v-html="link.text"></span>
          </NuxtLink>
        </li>
      </ul>
    </nav>
  </header>
</template>



<style scoped>
nav{
  width: 100%;
}
ul{
  display: flex;
}
ul>li{
  flex: 1 1 0px;
}
a{
  display: flex;
  justify-content: center;
  transition: all 0.5s;
  width: 100%;
  height: 100%;
}
a:hover{
  fill: #569709;
  color: #569709;
  background-color: #f3f7d9;
}
</style>